document.addEventListener('DOMContentLoaded',function(){
  
  var giftcancel = document.querySelector(".giftcancel");
  var giftbox = document.getElementById("giftbox");
  var giftbtn = document.getElementById("giftbtn");
  console.log("giftbtn",giftbtn);
  giftbtn.addEventListener("click",function(){

    giftbox.style.display = "block";
  });
    giftcancel.addEventListener("click",function(e){
    giftbox.style.display = "none";
  }) 
  
 })


